import courseCenter from "../../api/courseCenter";

const state = {
    matchTitleList: {},
    matchTitleListLoading: false,
    matchContentList: {},
    matchContentListLoading: false,
    matchContentModalVisible: false,

    classSubjectEditListLoading: false,
    classSubjectEditList: {},
    classSubjectEditListFilter: {},
    // 用户可见的单位，企业用户能看见所有单位，一定包含企业
    userDepartmentDictionary: {},

    lessonResponseListLoading: false,
    lessonResponseList: {},
    lessonResponseListFilter: {},
    lessonResponseNameListFilter: {},
    saveLessonDetail: {},

    editOutLineDetail: {},
    saveOutLineDetail: {},
    saveUserConfigDetail: [],

    lessonContentListLoading: false,
    lessonContentList: {},
    addLessonContentModalV1Visible: false,
    addLessonContentModalV2Visible: false,
    audioDetail: {},

    polyPhoneModalVisible: false,
    multiContentModalVisible: false,
    contentPickModalVisible: false,
    materialPickVisible: false,
    materialUploadVisible: false,
    textMaterialVisible: false,

    knowledgePointReviewModalVisible: false,
    pointReviewContentList: {},

    //   问题管理
    questionResponseListLoading: false,
    questionResponseList: {},
    questionResponseListFilter: {},
    answerQuestionModalVisible: false,
    //标签管理
    tagCategoryList: {},

    // 未读懂管理
    markResponseListLoading: false,
    markResponseList: {},
    markResponseListFilter: {},
    markDetailModalVisible: false,
};

const getters = {};
const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
    clearFilter(state) {
        state.classSubjectEditListFilter = {};
        state.lessonResponseListFilter = {};
        state.questionResponseListFilter = {};
    },
    clearMarkFilter(state) {
        state.lessonResponseNameListFilter = {}
        state.markResponseListFilter = {}
    }
};
const actions = {
    // eslint-disable-next-line no-empty-pattern
    async searchMaterialResource({}, payload) {
        return await courseCenter.searchMaterialResource(payload);
    },

    // eslint-disable-next-line no-empty-pattern
    async saveMaterialResource({}, payload) {
        return await courseCenter.saveMaterialResource(payload);
    },

    // eslint-disable-next-line no-empty-pattern
    async deleteMaterialResource({}, payload) {
        return await courseCenter.deleteMaterialResource(payload);
    },

    // eslint-disable-next-line no-empty-pattern
    async searchDisease({}, payload) {
        return await courseCenter.searchDisease(payload);
    },

    // eslint-disable-next-line no-empty-pattern
    async saveDisease({}, payload) {
        return await courseCenter.saveDisease(payload);
    },

    // eslint-disable-next-line no-empty-pattern
    async deleteDisease({}, payload) {
        return await courseCenter.deleteDisease(payload);
    },

    // eslint-disable-next-line no-empty-pattern
    async getMatchTitle({commit}, payload) {
        commit("setData", {key: "matchTitleListLoading", value: true});
        try {
            const params = {
                size: state.matchTitleList.size,
                ...payload,
            };
            const res = await courseCenter.getMatchTitle.getList(params);
            commit("setData", {key: "matchTitleList", value: res.data});
        } finally {
            commit("setData", {key: "matchTitleListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getMatchContent({commit}, payload) {
        commit("setData", {key: "matchContentListLoading", value: true});
        try {
            const params = {
                size: state.matchContentList.size,
                ...payload,
            };
            const res = await courseCenter.getMatchContent.getList(params);
            commit("setData", {key: "matchContentList", value: res.data});
        } finally {
            commit("setData", {key: "matchContentListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getClassSubjectEditList({commit}, payload) {
        // const result = await courseCenter.getUserDepartmentDictionary()
        // const departmentId = result.data[0].id
        commit("setData", {key: "classSubjectEditListLoading", value: true});
        const payloads = {
            ...payload,
            startTime: state.classSubjectEditListFilter.dateRange
                ? state.classSubjectEditListFilter.dateRange[0]
                : null,
            endTime: state.classSubjectEditListFilter.dateRange
                ? state.classSubjectEditListFilter.dateRange[1]
                : null,
        };
        payloads.dateRange = undefined;
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                // size: state.classSubjectEditList.size,
                // departmentId: departmentId,
                ...state.classSubjectEditListFilter,
                ...payloads,
            };
            const res = await courseCenter.getClassSubjectEditList.getList(params);
            commit("setData", {key: "classSubjectEditList", value: res.data});
        } finally {
            commit("setData", {key: "classSubjectEditListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getLessonResponseList({commit}, payload) {
        commit("setData", {key: "lessonResponseListLoading", value: true});
        const payloads = {
            ...payload,
            startTime: state.lessonResponseListFilter.dateRange
                ? state.lessonResponseListFilter.dateRange[0]
                : null,
            endTime: state.lessonResponseListFilter.dateRange
                ? state.lessonResponseListFilter.dateRange[1]
                : null,
        };
        payloads.dateRange = undefined;
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                page: state.lessonResponseList.page,
                size: state.lessonResponseList.size,
                ...state.lessonResponseListFilter,
                ...payloads,
            };
            const res = await courseCenter.getLessonResponseList.getList(params);
            commit("setData", {key: "lessonResponseList", value: res.data});
        } finally {
            commit("setData", {key: "lessonResponseListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getLessonResponseNameList({commit}, payload) {
        commit("setData", {key: "lessonResponseNameListLoading", value: true});
        const payloads = {
            ...payload,
            startTime: state.lessonResponseNameListFilter.dateRange
                ? state.lessonResponseNameListFilter.dateRange[0]
                : null,
            endTime: state.lessonResponseNameListFilter.dateRange
                ? state.lessonResponseNameListFilter.dateRange[1]
                : null,
        };
        payloads.dateRange = undefined;
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                page: state.lessonResponseList.page,
                size: state.lessonResponseList.size,
                ...state.lessonResponseNameListFilter,
                ...payloads,
            };
            const res = await courseCenter.getLessonResponseList.getList(params);
            commit("setData", {key: "lessonResponseNameList", value: res.data});
        } finally {
            commit("setData", {key: "lessonResponseNameListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getUserDepartmentDictionary({commit}) {
        const res = await courseCenter.getUserDepartmentDictionary();
        commit("setData", {key: "userDepartmentDictionary", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async moveLessonResponseList({}, payload) {
        await courseCenter.moveLessonResponseList(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteLessonForVersion({}, payload) {
        await courseCenter.deleteLessonForVersion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteLesson({}, payload) {
        await courseCenter.deleteLesson(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async copyLesson({}, payload) {
        return await courseCenter.copyLesson(
            payload.lessonId,
            payload.classSubjectId
        );
    },
    // eslint-disable-next-line no-empty-pattern
    async moveLesson({}, payload) {
        return await courseCenter.moveLesson(
            payload.lessonId,
            payload.classSubjectId
        );
    },
    // eslint-disable-next-line no-empty-pattern
    async saveLesson({}, payload) {
        return await courseCenter.saveLesson(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async initLessonVersion({}, payload) {
        return await courseCenter.initLessonVersion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getUserConfig({commit}, payload) {
        const res = await courseCenter.getUserConfig(payload);
        commit("setData", {key: "saveUserConfigDetail", value: res.data});
        return res;
    },
    // eslint-disable-next-line no-empty-pattern
    async saveUserConfig({}, payload) {
        await courseCenter.saveUserConfig(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getLessonEditOutline({commit}, payload) {
        const res = await courseCenter.getLessonEditOutline(payload);
        commit("setData", {key: "editOutLineDetail", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async saveLessonVersion({commit}, payload) {
        const res = await courseCenter.saveLessonVersion(payload);
        commit("setData", {key: "saveOutLineDetail", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async getLessonContent({}, payload) {
        // commit('setData', { key: 'lessonContentListLoading', value: true })
        return await courseCenter.getLessonContent(payload);
        // commit('setData', { key: 'lessonContentListLoading', value: false })
    },
    // eslint-disable-next-line no-empty-pattern
    async getAudioUrl({commit}, payload) {
        const res = await courseCenter.getAudioUrl(payload);
        commit("setData", {key: "audioDetail", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async saveLessonContent({}, payload) {
        await courseCenter.saveLessonContent(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async addBelowLessonContent({}, payload) {
        await courseCenter.addBelowLessonContent(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteLessonContent({}, payload) {
        await courseCenter.deleteLessonContent(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async moveLessonContent({}, payload) {
        await courseCenter.moveLessonContent(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async submitLessonVersion({}, payload) {
        await courseCenter.submitLessonVersion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getLessonPointReviewContentList({commit}, payload) {
        const res = await courseCenter.getLessonPointReviewContentList(payload);
        commit("setData", {key: "pointReviewContentList", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async savePointReviewContent({}, payload) {
        await courseCenter.savePointReviewContent(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deletePointReviewContent({}, payload) {
        await courseCenter.deletePointReviewContent(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getLessonQuestionResponseList({commit}, payload) {
        commit("setData", {key: "questionResponseListLoading", value: true});
        const payloads = {
            ...payload,
            startTime: state.questionResponseListFilter.dateRange
                ? state.questionResponseListFilter.dateRange[0]
                : null,
            endTime: state.questionResponseListFilter.dateRange
                ? state.questionResponseListFilter.dateRange[1]
                : null,
        };
        payloads.dateRange = undefined;
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                size: state.questionResponseList.size,
                ...state.questionResponseListFilter,
                ...payloads,
            };
            const res = await courseCenter.getLessonQuestionResponseList.getList(
                params
            );
            commit("setData", {key: "questionResponseList", value: res.data});
        } finally {
            commit("setData", {key: "questionResponseListLoading", value: false});
        }
    },

    // eslint-disable-next-line no-empty-pattern
    async getLessonMarkResponseList({commit}, payload) {
        commit("setData", {key: "markResponseListLoading", value: true});
        const payloads = {
            ...payload,
            startTime: state.markResponseListFilter.dateRange
                ? state.markResponseListFilter.dateRange[0]
                : null,
            endTime: state.markResponseListFilter.dateRange
                ? state.markResponseListFilter.dateRange[1]
                : null,
        };
        payloads.dateRange = undefined;
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                size: state.markResponseList.size,
                ...state.markResponseListFilter,
                ...payloads,
            };
            const res = await courseCenter.getLessonMarkResponseList.getList(
                params
            );
            commit("setData", {key: "markResponseList", value: res.data});
        } finally {
            commit("setData", {key: "markResponseListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveLessonQuestion({}, payload) {
        await courseCenter.saveLessonQuestion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async recommendLessonQuestion({}, payload) {
        await courseCenter.recommendLessonQuestion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTagCategoryList({commit}, payload) {
        const res = await courseCenter.getTagCategoryList(payload);
        commit("setData", {key: "tagCategoryList", value: res.data});
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
